// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is included in purchase.js and ends up affecting everything.
In particular, the form element selector changes all of the calculators!
It's being limited from all forms, to forms of class stripe (form.stripe)
*/
/*
#root {
    display: flex;
    align-items: flex-start;
  }
  */

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  /*display: flex;*/
  /*justify-content: center;*/
  align-content: center;
  height: 100vh;
  /*width: 97vw;*/
}

form.stripe {
  width: 60vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
}

form.twoco {
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
}

#payment-message {
  color: rgb(105, 115, 134);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */
button {
  background: rgba(59, 126, 161, 1);
  color: #ffffff;
  border-radius: var(--border-radius);
  border: 1px solid rgba(59, 126, 161, 1);
  padding: var(--button-padding);
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
}

button.stripe {
  /* Had to limit to only Stripe buttons, or it would break NavBar*/
  width: 100%;
}

button:hover {
  background: rgba(59, 126, 161, 0.8);
}

button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}

.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  transform: translateZ(0);
}

.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}

.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  transform-origin: 10.4px 10.2px;
  animation: loading 2s infinite ease 1.5s;
}

.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  transform-origin: 0px 10.2px;
  animation: loading 2s infinite ease;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  form {
    width: 90vw;
    min-width: initial;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/stripeApp.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;;;GAKG;;AAEH;EACE,0DAA0D;EAC1D,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB;gFAC8E;EAC9E,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;gFAC8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,cAAc;EACd,mCAAmC;EACnC,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,iEAAiE;EACjE,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,qCAAqC;AACrC;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAG3B,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,YAAY;EAEZ,+BAA+B;EAE/B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,YAAY;EAEZ,4BAA4B;EAE5B,mCAAmC;AACrC;;AAEA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* This file is included in purchase.js and ends up affecting everything.\r\nIn particular, the form element selector changes all of the calculators!\r\nIt's being limited from all forms, to forms of class stripe (form.stripe)\r\n*/\r\n/*\r\n#root {\r\n    display: flex;\r\n    align-items: flex-start;\r\n  }\r\n  */\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\r\n  font-size: 16px;\r\n  -webkit-font-smoothing: antialiased;\r\n  /*display: flex;*/\r\n  /*justify-content: center;*/\r\n  align-content: center;\r\n  height: 100vh;\r\n  /*width: 97vw;*/\r\n}\r\n\r\nform.stripe {\r\n  width: 60vw;\r\n  min-width: 500px;\r\n  align-self: center;\r\n  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\r\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\r\n  border-radius: 7px;\r\n  padding: 40px;\r\n}\r\n\r\nform.twoco {\r\n  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\r\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\r\n  border-radius: 7px;\r\n}\r\n\r\n#payment-message {\r\n  color: rgb(105, 115, 134);\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n  padding-top: 12px;\r\n  text-align: center;\r\n}\r\n\r\n#payment-element {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Buttons and links */\r\nbutton {\r\n  background: rgba(59, 126, 161, 1);\r\n  color: #ffffff;\r\n  border-radius: var(--border-radius);\r\n  border: 1px solid rgba(59, 126, 161, 1);\r\n  padding: var(--button-padding);\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\r\n}\r\n\r\nbutton.stripe {\r\n  /* Had to limit to only Stripe buttons, or it would break NavBar*/\r\n  width: 100%;\r\n}\r\n\r\nbutton:hover {\r\n  background: rgba(59, 126, 161, 0.8);\r\n}\r\n\r\nbutton:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n/* spinner/processing state, errors */\r\n.spinner,\r\n.spinner:before,\r\n.spinner:after {\r\n  border-radius: 50%;\r\n}\r\n\r\n.spinner {\r\n  color: #ffffff;\r\n  font-size: 22px;\r\n  text-indent: -99999px;\r\n  margin: 0px auto;\r\n  position: relative;\r\n  width: 20px;\r\n  height: 20px;\r\n  box-shadow: inset 0 0 0 2px;\r\n  -webkit-transform: translateZ(0);\r\n  -ms-transform: translateZ(0);\r\n  transform: translateZ(0);\r\n}\r\n\r\n.spinner:before,\r\n.spinner:after {\r\n  position: absolute;\r\n  content: \"\";\r\n}\r\n\r\n.spinner:before {\r\n  width: 10.4px;\r\n  height: 20.4px;\r\n  background: #5469d4;\r\n  border-radius: 20.4px 0 0 20.4px;\r\n  top: -0.2px;\r\n  left: -0.2px;\r\n  -webkit-transform-origin: 10.4px 10.2px;\r\n  transform-origin: 10.4px 10.2px;\r\n  -webkit-animation: loading 2s infinite ease 1.5s;\r\n  animation: loading 2s infinite ease 1.5s;\r\n}\r\n\r\n.spinner:after {\r\n  width: 10.4px;\r\n  height: 10.2px;\r\n  background: #5469d4;\r\n  border-radius: 0 10.2px 10.2px 0;\r\n  top: -0.1px;\r\n  left: 10.2px;\r\n  -webkit-transform-origin: 0px 10.2px;\r\n  transform-origin: 0px 10.2px;\r\n  -webkit-animation: loading 2s infinite ease;\r\n  animation: loading 2s infinite ease;\r\n}\r\n\r\n@keyframes loading {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  form {\r\n    width: 90vw;\r\n    min-width: initial;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
